import FormSectionContainer from "../../components/Form/FormSectionContainer";
import FormSectionTitle from "../../components/styled/FormSectionTitle";

export default function VehicleInfoField({ watch, control, errors, setValue, others, unregister }) {
  const fields = [
    {
      label: "Name",
      name: "car.name",
      type: "text",
      placeholder: "Name",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Chassis No.",
      name: "car.chassis",
      type: "text",
      placeholder: "Chassis No.",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Engine No.",
      name: "car.engine",
      type: "text",
      placeholder: "Engine No.",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Year/Model",
      name: "car.year",
      type: "number",
      placeholder: "Year / Model",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Color",
      name: "car.color",
      type: "text",
      placeholder: "Color",
      col: { md: 4, lg: 3 }
    },
    {
      label: "CC",
      name: "car.cc",
      type: "number",
      placeholder: "CC",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Fuel",
      name: "car.fuel",
      type: "text",
      placeholder: "Fuel",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Tyre Size",
      name: "car.tyre_size",
      type: "text",
      placeholder: "Tyre Size",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Mileage",
      name: "car.mileage",
      type: "text",
      placeholder: "Mileage",
      col: { md: 4, lg: 3 }
    }
  ];

  const isLoading = false;

  return (
    <FormSectionContainer
      setValue={setValue}
      fields={fields}
      control={control}
      watch={watch}
      errors={errors}
      loading={isLoading}
      unregister={unregister}>
      <div className="col-12">
        <FormSectionTitle>Vehicle Information</FormSectionTitle>
      </div>
    </FormSectionContainer>
  );
}
